'use strict';

angular.module('shiftTraderApp')
  .directive('saNoteContextMenu', ['NotesStore', '$confirm', 'EditNoteModal', function (NotesStore, $confirm, EditNoteModal) {
    return {
      restrict: 'A',
      require: '^saNote',
      templateUrl: 'views/directives/notes/saNoteContextMenu.html',
      controllerAs: 'ContextMenuCtrl',
      controller: ['$scope', function($scope) {
        var vm = this;

        vm.actions = undefined;
        vm.NoteCtrl = $scope.NoteCtrl;

        vm.NoteCtrl.note.$getPermissions()
          .then(function(permDict) {
            var temp = [];
            if (permDict && permDict.canEdit) {
              temp.push({
                label: 'Edit',
                click: function() {
                  EditNoteModal.open(vm.NoteCtrl.note.id);
                }
              })
            }

            if (permDict && permDict.canDelete) {
              temp.push({
                label: 'Delete',
                click: function() {
                  $confirm({
                    title: 'Deleting Note',
                    text: 'Are you sure you want to delete this Note? This action is irreversible.',
                    ok: 'Delete',
                    cancel: 'Cancel'
                  }).then(function() {
                      NotesStore.destroyNote(vm.NoteCtrl.note.id);
                    }, function() {
                      // do nothing
                    })
                }
              });
            }

            if (!vm.NoteCtrl.note.$isReply()) {
              temp.push({
                label: 'Change Permission Level',
                click: function() {
                  EditNoteModal.open(vm.NoteCtrl.note.id);
                }
              })
            }

            vm.actions = temp;
          }, function() {

          });

      }],
      link: function(scope, element, attrs, parentCtrl) {
        scope.NoteCtrl = parentCtrl;
      }
    }
  }]);
